/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForAwsSaas extends models.StorageConfigurationForSaasUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationBaseForAwsSaas.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForAwsSaas>): StorageConfigurationBaseForAwsSaas {
        let obj = Object.assign(new StorageConfigurationBaseForAwsSaas(), model);
        StorageConfigurationBaseForAwsSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForAwsSaas>): StorageConfigurationBaseForAwsSaas {
        if (!model) return null;
        return StorageConfigurationBaseForAwsSaas.newInstance(<StorageConfigurationBaseForAwsSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForAwsSaas) {
        if (!obj) return;

        models.StorageConfigurationBaseForAwsSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForAwsSaas): boolean {
        if (models.StorageConfigurationForSaasUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationBaseForAwsSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Storage Bucket Name
     */
    bucket_name: string;

    /**
     * File Path in the Bucket
     */
    file_path: string;

}
